"use client";

import _objectSpread from "D:\\sushrutpandey\\datahubnew\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "D:\\sushrutpandey\\datahubnew\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
import PageItem, { Ellipsis, First, Last, Next, Prev } from './PageItem';
import { jsx as _jsx } from "react/jsx-runtime";
var Pagination = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
    className = _ref.className,
    size = _ref.size,
    props = _objectWithoutProperties(_ref, ["bsPrefix", "className", "size"]);
  var decoratedBsPrefix = useBootstrapPrefix(bsPrefix, 'pagination');
  return /*#__PURE__*/_jsx("ul", _objectSpread({
    ref: ref
  }, props, {
    className: classNames(className, decoratedBsPrefix, size && "".concat(decoratedBsPrefix, "-").concat(size))
  }));
});
Pagination.displayName = 'Pagination';
export default Object.assign(Pagination, {
  First: First,
  Prev: Prev,
  Ellipsis: Ellipsis,
  Item: PageItem,
  Next: Next,
  Last: Last
});